"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function () {
  const {
    ref: indexRef,
    isVisible: indexVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const headlineWords = ["Permanent.", "Compliant.", "Specified", "by", "name."];
  const stats = [{
    value: "12 YRS",
    label: "of engineering"
  }, {
    value: "47 PROJECTS",
    label: "marked daily"
  }, {
    value: "8 STANDARDS",
    label: "families met"
  }];
  return <section data-section-id="5063" id="the-evermark-standard" className="bg-background text-foreground py-24 md:py-40 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-10">
          {}
          <div className="lg:col-span-7 flex flex-col">
            {}
            <div ref={indexRef} className={`font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground transition-all duration-700 ease-out ${indexVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              — 01 / AUTHORITY
            </div>

            {}
            <h2 ref={headlineRef} className="font-default font-bold text-5xl sm:text-6xl md:text-7xl lg:text-7xl xl:text-8xl leading-[1.05] mt-10 md:mt-14 tracking-tight">
              {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden mr-[0.25em] align-baseline">
                  <span className={`inline-block transition-all ease-out ${word === "name." ? "italic text-primary" : ""} ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[110%]"}`} style={{
                transitionDuration: "900ms",
                transitionDelay: `${i * 90}ms`
              }}>
                    {word}
                  </span>
                </span>)}
            </h2>

            {}
            <div className={`mt-10 md:mt-14 transition-all duration-700 ease-out ${headlineVisible ? "opacity-100 w-[60px]" : "opacity-0 w-0"}`} style={{
            transitionDelay: "700ms"
          }}>
              <Separator className="bg-primary h-px" />
            </div>

            {}
            <div ref={bodyRef} className={`mt-10 md:mt-12 max-w-[50ch] transition-all duration-1000 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              <p className="font-default text-lg md:text-xl leading-relaxed text-foreground/85">
                Evermark Industrial Solutions provides precision identification for critical infrastructure. We produce{" "}
                <span className="relative inline-block">
                  <span className="relative z-10">MIL-SPEC nameplates and tags</span>
                  <span className="absolute left-0 right-0 bottom-0 h-px bg-primary" />
                </span>{" "}
                that withstand the harshest industrial environments. Our process is simple: you provide the spec, we provide the permanent mark. We bridge the gap between{" "}
                <span className="relative inline-block">
                  <span className="relative z-10">engineering intent and physical reality</span>
                  <span className="absolute left-0 right-0 bottom-0 h-px bg-primary" />
                </span>
                , delivering compliant identification for clients who demand absolute technical accuracy.
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 lg:col-start-8 relative">
            <div ref={imageRef} className={`relative transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              {}
              <div className="relative w-full aspect-[3/4] sm:aspect-[4/5] lg:aspect-[3/4.2] overflow-hidden rounded-lg shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving_process.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving_process.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving_process.webp-wvc-sizes" alt="Precision laser engraving on industrial stainless steel" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>

              {}
              <div className={`absolute left-[-1.5rem] sm:left-[-3rem] bottom-[-2.5rem] sm:bottom-[-4rem] w-[45%] sm:w-[50%] aspect-square overflow-hidden rounded-lg shadow-xl transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
              transitionDelay: "350ms"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_nameplate_detail.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_nameplate_detail.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_nameplate_detail.png-wvc-sizes" alt="Detail of a MIL-SPEC phenolic nameplate" loading="lazy" decoding="async" className="w-full h-full object-cover" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/Phenolic_Legend_Plates_2-scaled.webp" />
              </div>
            </div>
          </div>
        </div>

        {}
        
      </div>
    </section>;
}